module.exports = __webpack_public_path__ + "img/spot-1.4f2a3d77.png";